(function ($, njm) {
    'use strict';
    njm.views.headerMobile = Backbone.View.extend({

        /**
         * Events
         */
        events: {
            'click .toggle': 'toggleMenu',
            'click .cover': 'toggleMenu',
            'click .close': 'toggleMenu',
            'click .expendable > label': 'toggleSubMenu',
            'click .search a': 'submitSearch',
            'keyup .search input': 'submitSearch'
        },

        // supported medias for this view
        medias: ['mobile', 'tablet'],

        /**
         * Initialize
         */
        initialize: function () {
            this.template = $('#comp-header-mobile').html();
            this.$body = $('body');

            // Render
            this.render();
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template);
            this.$mobileMenu = this.$('.comp-header-mobile');
        },

        /**
         * Toggle Mobile Menu
         */
        toggleMenu: function () {
            this.$mobileMenu.toggleClass('expend');
            this.$body.toggleClass('lock', this.$mobileMenu.hasClass('expend'));
        },

        /**
         * Toggle Mobile Sub Menu
         * @param {Object} e
         */
        toggleSubMenu: function (e) {
            $(e.currentTarget).parent().toggleClass('open');
        },

        /**
         * Submit search
         */
        submitSearch: function (e) {
            if ((e.type === 'keyup' && e.keyCode === 13) || e.type === 'click') {
                e.preventDefault();
                var form = this.$('.search form')[0];
                form.submit();
            }
        }

    });
})(jQuery, njm);
